import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList';

type Payload = { depositAmount: number; monthlyAmount: number };
type Props = ModalProps<Payload>;

function DepositSuccess({ closeModal, confirmAction, payload: { depositAmount, monthlyAmount } }: Props) {
  const { t } = useTranslation(['Modal', 'Common']);

  return (
    <Modal title={t('DepositSuccess.title')}>
      <div className="flex flex-col gap-4">
        <p>{t('DepositSuccess.info')}</p>
        <DataList>
          <DataListItem>
            <DataListLabel>{t('DepositSuccess.depositAmount')}</DataListLabel>
            <DataListValue>{t('Common:moneyWithTrailingZeros', { amount: depositAmount })}</DataListValue>
          </DataListItem>
          <DataListItem>
            <DataListLabel>{t('DepositSuccess.monthlyAmount')}</DataListLabel>
            <DataListValue>{t('Common:moneyWithTrailingZeros', { amount: monthlyAmount })}</DataListValue>
          </DataListItem>
        </DataList>
      </div>
      <ModalActions>
        <Button onClick={confirmAction ?? closeModal}>{t('DepositSuccess.button')}</Button>
      </ModalActions>
    </Modal>
  );
}

export default DepositSuccess;
